const getters = {
	show: state => state.disclosure.show,
	productList: state => state.disclosure.productList,
	time: state => state.disclosure.time,
	url: state => state.disclosure.url,
}
export default getters
